import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Modal } from 'react-bootstrap'

import ReportTable from '../../../templates/ReportTable/ReportTable'
import Loading from '../../../templates/UI/Loading/Loading'
import DateRangeFilter from '../../../pages/Reports/Filters/DateRangeFilter/DateRangeFilter'
import useDateRangeFilter from '../../../hooks/useDateRangeFilter'
import callAPI from '../../../helpers/callAPI'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import AffiliateNavbar from '../../../pages/Affiliate/Templates/AffiliateNavbar/AffiliateNavbar'
import CampaignNavbar from '../../../pages/Campaign/CampaignNavBar/CampaignNavBar'
import DownloadCSV from '../../../templates/DownloadCSV/DownloadCSV'
import useQueryParams from '../../../hooks/useQueryParams'
import ReportAppliedFilters from '../../../templates/ReportAppliedFilters/ReportAppliedFilters'
import Campaign from '../../../templates/Campaign/Campaign'
import AdvertiserNavbar from '../../Advertiser/AdvertiserNavBar/AdvertiserNavBar'
import CampaignSetupContent from '../../../components/CampaignSetupContent/CampaignSetupContent'
import useCallApi from '../../../hooks/useCallApi'

export default function CampaignSetup({ advertiserId, campaignId, showSystemMessage }) {

    

    const { data, dataLoaded, refetch } = useCallApi(`campaigns/worksheetReportItem?id=${campaignId}&advertiser=${advertiserId}`, 'GET', {}, [campaignId, advertiserId], showSystemMessage)
    document.title = `Campaign Setup: ${dataLoaded ? data.data[0].offer_name : ''}`
    return (
        <>
            {
                (advertiserId > 0 && advertiserId !== '') &&
                <div className="page-header d-flex align-items-center">
                    <h1 className="mb-h1">Campaign Setup</h1>
                    <div className="ml-5">
                        <AdvertiserNavbar advertiserId={advertiserId} showSystemMessage={showSystemMessage} />
                    </div>
                </div>
            }  
            {dataLoaded ? (
                <div className="row">
                    <div className="col-xl-7">
                        <CampaignSetupContent campaignId={campaignId} showSystemMessage={showSystemMessage} campaignPhaseData={data.data[0]} refetch={refetch} />
                    </div>
                </div>
                
            ) : (
                <Loading />
            )}
        </>
    )
}
